import {
	GET_LOTS_START,
	GET_LOTS_SUCCESS,
	GET_LOTS_FAIL,
	GET_BUILDING_INFO_START,
	GET_BUILDING_INFO_SUCCESS,
	GET_BUILDING_INFO_FAIL,
	SET_LOT_SELECTED_ID,
	SET_LOT_WITH_MODEL_SELECTED,
	SET_LOTS_SELECTED,
	PUSH_LOTS_SELECTED,
	POP_LOTS_SELECTED,
	GET_CO_BROKERS_START,
	GET_CO_BROKERS_SUCCESS,
	GET_CO_BROKERS_FAIL,
	GET_SALES_AGENTS_START,
	GET_SALES_AGENTS_SUCCESS,
	GET_SALES_AGENTS_FAIL,
	SET_SHOW_AVAILABLE_LOTS,
	GET_FIT_MODELS_SUCCESS,
	GET_FIT_MODELS_FAIL,
	GET_MODEL_LOTS_SUCCESS,
	GET_MODEL_LOTS_FAIL,
	SET_LOT_SIZE_TYPE,
	SET_FILTERED_LOTS,
} from './types';
import getLotsAPI from '../../api/Siteplan/getLots.api';
import getBuildingInfoAPI from '../../api/Siteplan/getBuildingInfo.api';
import getCoBrokersAPI from '../../api/Siteplan/getCoBrokers.api';
import { getAllSalesAgents } from '../../api/Deals/getAllSalesAgents.api';
import getLotModels from '../../api/Siteplan/getLotModels.api';
import getModelLots from '../../api/Siteplan/getModelLots.api';

export const getLots = (userDetails) => {
	return async (dispatch) => {
		try {
			dispatch(getLotsStart());
			getLotsAPI(
				userDetails,
				(lots, availability, coBrokerAssignedLots) => {
					dispatch(
						getLotsSuccess({
							lots,
							availability,
							coBrokerAssignedLots,
						})
					);
				}
			);
		} catch (error) {
			dispatch(getLotsFail());
		}
	};
};

export const getLotsStart = () => ({
	type: GET_LOTS_START,
});

export const getLotsSuccess = (payload) => ({
	type: GET_LOTS_SUCCESS,
	payload,
});

export const getLotsFail = () => ({
	type: GET_LOTS_FAIL,
});

export const getBuildingInfo = () => {
	return async (dispatch) => {
		try {
			dispatch(getBuildingInfoStart());
			getBuildingInfoAPI((buildingInfo) => {
				dispatch(getBuildingInfoSuccess(buildingInfo));
			});
		} catch (error) {
			dispatch(getBuildingInfoFail());
		}
	};
};

export const getFitModels = (lotId) => {
	return async (dispatch) => {
		try {
			getLotModels(lotId, (returned) => {
				dispatch(getFitModelsSuccess(returned));
			});
		} catch (error) {
			dispatch(getFitModelsFail(error));
		}
	};
};

export const getModelLotsFit = (modelId) => {
	return async (dispatch) => {
		try {
			getModelLots(modelId, (returned) => {
				console.log('returende', returned);
				dispatch(getModelLotsFitSuccess(returned));
			});
		} catch (error) {
			dispatch(getModelLotsFitFail(error));
		}
	};
};
//set lot size type
export const setLotSizeType = (payload) => ({
	type: SET_LOT_SIZE_TYPE,
	payload,
});

export const setFilteredLots = (payload) => ({
	type: SET_FILTERED_LOTS,
	payload,
});

export const getModelLotsFitSuccess = (payload) => ({
	type: GET_MODEL_LOTS_SUCCESS,
	payload,
});
export const getModelLotsFitFail = (payload) => ({
	type: GET_MODEL_LOTS_FAIL,
	payload,
});

export const getFitModelsSuccess = (payload) => ({
	type: GET_FIT_MODELS_SUCCESS,
	payload,
});

export const getFitModelsFail = (payload) => ({
	type: GET_FIT_MODELS_FAIL,
	payload,
});

export const getBuildingInfoStart = () => ({
	type: GET_BUILDING_INFO_START,
});

export const getBuildingInfoSuccess = (payload) => ({
	type: GET_BUILDING_INFO_SUCCESS,
	payload,
});

export const getBuildingInfoFail = () => ({
	type: GET_BUILDING_INFO_FAIL,
});

export const setLotSelectedId = (payload) => ({
	type: SET_LOT_SELECTED_ID,
	payload,
});

export const setLotWithModelSelected = (payload) => ({
	type: SET_LOT_WITH_MODEL_SELECTED,
	payload,
});

export const setLotsSelected = (payload) => ({
	type: SET_LOTS_SELECTED,
	payload,
});

export const pushLotsSelected = (payload) => ({
	type: PUSH_LOTS_SELECTED,
	payload,
});

export const popLotsSelected = (payload) => ({
	type: POP_LOTS_SELECTED,
	payload,
});

export const getCoBrokers = () => {
	return async (dispatch) => {
		try {
			dispatch(getCoBrokersStart());
			getCoBrokersAPI((buildingInfo) => {
				dispatch(getCoBrokersSuccess(buildingInfo));
			});
		} catch (error) {
			dispatch(getCoBrokersFail());
		}
	};
};

export const getCoBrokersStart = () => ({
	type: GET_CO_BROKERS_START,
});

export const getCoBrokersSuccess = (payload) => ({
	type: GET_CO_BROKERS_SUCCESS,
	payload,
});

export const getCoBrokersFail = () => ({
	type: GET_CO_BROKERS_FAIL,
});

export const getSalesAgents = () => {
	return async (dispatch) => {
		try {
			dispatch(getSalesAgentsStart());
			getAllSalesAgents((salesAgents) => {
				dispatch(getSalesAgentsSuccess(salesAgents));
			});
		} catch (error) {
			dispatch(getSalesAgentsFail());
		}
	};
};

export const getSalesAgentsStart = () => ({
	type: GET_SALES_AGENTS_START,
});

export const getSalesAgentsSuccess = (payload) => ({
	type: GET_SALES_AGENTS_SUCCESS,
	payload,
});

export const getSalesAgentsFail = () => ({
	type: GET_SALES_AGENTS_FAIL,
});

export const setShowAvailableLots = (payload) => ({
	type: SET_SHOW_AVAILABLE_LOTS,
	payload,
});
